import { render, staticRenderFns } from "./DisplayOptions.vue?vue&type=template&id=4813a19e&scoped=true"
import script from "./DisplayOptions.vue?vue&type=script&lang=js"
export * from "./DisplayOptions.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./DisplayOptions.vue?vue&type=style&index=1&id=4813a19e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4813a19e",
  null
  
)

export default component.exports